import NextImage, { StaticImageData } from 'next/image'
import { ComponentProps, FC } from 'react'

import { Section } from 'components/section'
import { Heading } from 'components/heading'
import { Link, LinkButton } from 'components/links'
import { routes } from 'utils/routes'
import { AvatarsOfTeamMembers } from 'components/team-members/avatars-of-team-members'

import classes from './learn-more.module.css'
import joinImg from './images/join-us.jpg'
import { getAdaptiveImageSize } from '../../../utils/media'

interface NavItem {
  title: string
  image?: StaticImageData
  component?: 'teamAvatars'
  link: string
  linkName: string
  description: string
}

const NAV_ITEMS: NavItem[] = [
  {
    link: routes.meetTheTeam,
    linkName: 'meet the team',
    title: 'Meet the team',
    description: 'We’re a passionate team of creators, pioneers, and industry experts.',
    component: 'teamAvatars',
  },
  {
    link: routes.joinUs,
    linkName: 'view openings',
    title: 'Join us',
    description: 'We’re growing, and always looking for talented people.',
    image: joinImg,
  },
]

interface LearnMoreProps extends ComponentProps<typeof AvatarsOfTeamMembers> {}

export const LearnMore: FC<LearnMoreProps> = ({ peopleAvatars }) => {
  return (
    <div className={classes.container}>
      <Section>
        <Heading theme="h2" className={classes.sectionTitle}>
          Learn more about REZITRADE
        </Heading>

        <ul className={classes.list}>
          {NAV_ITEMS.map(({ linkName, link, image, title, description, component }) => (
            <li className={classes.listItem} key={title}>
              <Link href={link} className={classes.imageContainer}>
                {image && (
                  <NextImage
                    src={image}
                    alt={title}
                    fill
                    placeholder="blur"
                    sizes={getAdaptiveImageSize({
                      tablet: '33vw',
                      mobile: '100vw',
                      default: '33vw',
                    })}
                    quality={90}
                  />
                )}
                {component === 'teamAvatars' && (
                  <AvatarsOfTeamMembers peopleAvatars={peopleAvatars} />
                )}
              </Link>

              <Heading theme="h5" component="h4" className={classes.itemTitle}>
                {title}
              </Heading>
              <p className={classes.description}>{description}</p>
              <LinkButton theme="accentLinkToMobileBtn" href={link} className={classes.link}>
                {linkName}
              </LinkButton>
            </li>
          ))}
        </ul>
      </Section>
    </div>
  )
}
